import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/navigation/navigation.service';

@Directive({
    selector: '[cvNavigationSidebarClass]'
})
export class NavigationSidebarClassDirective implements AfterViewInit, OnDestroy {
    private _subscription: Subscription;

    constructor(
        private element: ElementRef<HTMLElement>,
        private service: NavigationService
    ) {

    }

    ngAfterViewInit() {
        const sidebarEl = document.getElementById('mnuNavigation');
        if (sidebarEl == null) {
            this.element.nativeElement.classList.add('no-sidebar');
            return;
        }

        this._subscription = this.service.sidebarActiveSubject.subscribe(sidebarActive => {
            const classList = new Set(this.element.nativeElement.className.split(' '));
            if (classList.has('active') && !sidebarActive) {
                classList.delete('active');
            } else if (!classList.has('active') && sidebarActive) {
                classList.add('active');
            }
            this.element.nativeElement.className = Array.from(classList).join(' ');
        });
    }

    ngOnDestroy() {
        this._subscription?.unsubscribe();
    }
}
